import type { GraphQLError } from 'graphql';

import { createEditorContentUnifiedQueryVariables } from '@confluence/editor-content-unified-query/entry-points/createEditorContentUnifiedQueryVariables.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import contentAppearanceQuery, {
	type contentAppearanceQuery$data,
	type contentAppearanceQuery$variables,
} from './__generated__/contentAppearanceQuery.graphql.ts';

export const preloadDraftContentAppearance = (
	contentId: contentAppearanceQuery$variables['contentId'],
	useCache: boolean = true,
): Promise<{
	data: contentAppearanceQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	return query<
		contentAppearanceQuery$data,
		contentAppearanceQuery$variables & { cacheBuster?: number }
	>({
		query: contentAppearanceQuery,
		variables:
			contentId && expValEquals('confluence_editor_content_unified_query', 'isEnabled', true)
				? {
						...createEditorContentUnifiedQueryVariables({ contentId }),
						...(!useCache ? { cacheBuster: Date.now() } : {}),
					}
				: {
						contentId,
						status: ['current', 'draft'],
						...(!useCache ? { cacheBuster: Date.now() } : {}),
					},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
		// Match Apollo's warm-cache behavior across editor unmounts and subsequent page visits.
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr -- This controls request-scoped cache retention, not rendered output.
		relayQueryPreloadRetention: process.env.REACT_SSR ? undefined : 'environment',
	});
};
